import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetOtherGroupsByInstructor = async (idCenter, idRole, groupSelected, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            idUserRol: idRole,
            idGroupSelected: groupSelected
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetOtherGroupsByInstructor"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetOtherGroupsByInstructor", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()

        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetOtherGroupsByInstructor DL Groups', error)
        return { success: false, message: 'No ha sido posible obtener el listado de grupos. Intenta actualizar la página o intenta actualizarla más tarde.' }
    }
}

const MoveZtudentBetweenGroups = async (idCenter, idRole, ztudentSelected, groupFromSelected, groupToSelected, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            idUserRol: idRole,
            idUserStudent: ztudentSelected.idZtudiante,
            idGroupFrom: groupFromSelected,
            idGroupTo: groupToSelected
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/MoveZtudentBetweenGroups"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/MoveZtudentBetweenGroups", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()

        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('MoveZtudentBetweenGroups DL Groups', error)
        return { success: false, message: 'No ha sido posible obtener el listado de grupos. Intenta actualizar la página o intenta actualizarla más tarde.' }
    }
}

/**
 * Invita (copia) a uno o varios Ztudiantes de un grupo a otro, SIN quitarlos del grupo
 * origen (quedan inscritos en ambos). A diferencia de MoveZtudentBetweenGroups, acepta un
 * lote de idZtudiantes en una sola petición, y regresa un outcome por cada uno.
 * IdUser se ignora del lado del backend: el Gateway lo deriva del token.
 */
const InviteFromAnotherGroup = async (idGroupFrom, idGroupTo, idZtudiantes, token) => {
    try {
        const dataToSend = {
            IdGroupFrom: idGroupFrom,
            IdGroupTo: idGroupTo,
            IdZtudiantes: idZtudiantes
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/InviteFromAnotherGroup"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('InviteFromAnotherGroup DL ChangeGroup', error)
        return { success: false, message: 'No ha sido posible invitar a los Ztudiantes al grupo. Intenta actualizar la página o intenta actualizarla más tarde.' }
    }
}

export { GetOtherGroupsByInstructor, MoveZtudentBetweenGroups, InviteFromAnotherGroup };